import React from 'react';
import { PropTypes } from 'prop-types';
import * as UI from '../../../ui';
import { FormattedMessage, useIntl } from 'react-intl';
import Config from '../../../../config';

import Image from '../Image';

const { DynamicContainer, Title, TitleTypes, LocalizedLink, Text, TextTypes } = UI;

const NotFound = ({ styles, rules }) => {
    const { formatMessage } = useIntl();

    const formattedFbUrl = formatMessage({ id: '404.description.facebook.url' });
    const formattedigUrl = formatMessage({ id: '404.description.instagram.url' });

    return (
        <>
            <span className={styles.corner}>404</span>
            <DynamicContainer extend={rules.extendContainer} isFluid>
                <Title extend={rules.extendTitle} type={TitleTypes.H1} as={TitleTypes.H1}>
                    <FormattedMessage id="404.title" />
                </Title>
                <Image src="404/404.jpg" alt="404.image.alt" />
                <LocalizedLink className={styles.link} to={Config.routes['/']}>
                    <FormattedMessage id="404.link.home" />
                </LocalizedLink>
                <Text as={TextTypes.PARAGRAPH} type={TextTypes.LARGE} extend={rules.extendDesc}>
                    <FormattedMessage
                        id="404.description"
                        values={{
                            fbLink: (
                                <a
                                    className={styles.descLink}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    href={formattedFbUrl}
                                >
                                    <FormattedMessage id="404.description.facebook" />
                                </a>
                            ),
                            igLink: (
                                <a
                                    className={styles.descLink}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    href={formattedigUrl}
                                >
                                    <FormattedMessage id="404.description.instagram" />
                                </a>
                            ),
                        }}
                    />
                </Text>
            </DynamicContainer>
        </>
    );
};

NotFound.propTypes = {
    styles: PropTypes.shape().isRequired,
    rules: PropTypes.shape().isRequired,
};

export default NotFound;
